/*! global-search */

$(document).ready(function () {
    $('main.search-results .search-text').each(function (e) {

        var url = window.location.href;
        var hashes = url.split("?")[1];
        var hash = hashes.split('&');
        
        for (var i = 0; i < hash.length; i++) {
            params = hash[i].split("=");
            if (params[0] === 'searchtext') {
                var searchText = params[1];
                searchText = decodeURIComponent(searchText.replace(/\+/g, ' '));
                $(this).val(searchText);
            }
        }

    });
});

function AddSearchText(event, overrideUrl) {
    event.preventDefault();
    let url = new URL(overrideUrl ? window.location.origin + overrideUrl : window.location.href);
    let search_params = url.searchParams;
    search_params.set('searchtext', event.target.querySelector('input').value);
    search_params.set('searchmode', 'allwords');
    url.search = search_params.toString();
    window.location = url.toString();
}

function HeaderSearchKeyTrigger(event) {
    if (event.key == 13) {
        SubmitHeaderSearchForm(event);
    }
}

function HeaderSearchClickTrigger(event) {
    SubmitHeaderSearchForm(event);
}

function SubmitHeaderSearchForm(event) {
    let form = document.getElementById(event.target.id);
    form.submit();
}